import { render, staticRenderFns } from "./customConfirm.vue?vue&type=template&id=cfbafbe0&scoped=true&"
import script from "./customConfirm.vue?vue&type=script&lang=js&"
export * from "./customConfirm.vue?vue&type=script&lang=js&"
import style0 from "./customConfirm.vue?vue&type=style&index=0&id=cfbafbe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbafbe0",
  null
  
)

export default component.exports